import React, { } from "react";
import { Form, Col } from 'react-bootstrap';
import { useDispatch } from 'redux-react-hook';
import ReactPlayer from "react-player"

export default function SettingVideo(props) {
    const questionIndex = props.index;
    const data = props.data || "";
    const dispatch = useDispatch();
    // console.log(props);

    function onChange(e) {
        try {
            const tmp = e.target.value;
            // console.log(tmp)
            dispatch({
                type: "QUESTION_SET_MA",
                key: "video",
                index: questionIndex,
                data: tmp
            });
        } catch (e) {

        }
    }

    function render() {
        return (
            <>
                <Form.Group>
                    <Form>
                        <Form.Row>
                            <Form.Label column xs="3">Youtube影片連結:</Form.Label>
                            <Col className="text-left">
                                <Form.Control onChange={onChange} type="text" name={questionIndex + "rand-sub"} value={data} />
                            </Col>
                        </Form.Row>
                        <Form.Row className="mt-2">
                            <Form.Label className="text-muted">
                                請貼上完整網址、不要使用短網址唷！<br />
                                請注意，未經許可擅用他人在網路上的影片，不但沒有禮貌，更是侵權行為喔。
                            </Form.Label>
                        </Form.Row>
                    </Form>
                </Form.Group>
                <Col>
                    <ReactPlayer url={data} style={{ "maxHeight": "200px", "maxWidth": "350px" }} />
                    {/* <video src={data} style={{"max-height":"80px", "max-width":"200px"}}/> */}
                </Col>
            </>
        );
    }

    return render();
}
